<script setup lang="ts">
import { onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";

import SkoreSpinner from "@/components/ui/SkoreSpinner.vue";
import FullPageCenteredLayout from "@/layouts/FullPageCenteredLayout.vue";
import { RouteNames } from "@/router";
import { useApi } from "@/services/api";

const api = useApi();
const route = useRoute();
const router = useRouter();

onMounted(async () => {
  const loginPath = route.path;
  const successRoute = router.resolve({ name: RouteNames.LoginSuccess });
  const baseAbsolutePath = document.baseURI.replace(loginPath, "");
  const successUri = baseAbsolutePath + successRoute.fullPath;
  await api.login(successUri);
});
</script>

<template>
  <FullPageCenteredLayout>
    <template #title>Redirecting to our authentication system.</template>

    <main class="login">
      <SkoreSpinner />
    </main>
  </FullPageCenteredLayout>
</template>

<style scoped>
.login {
  text-align: center;
}
</style>
